import { connect } from "react-redux";
import {cloneDeep, groupBy} from "lodash";

import Select from "react-select";

import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/20/solid";
import { Actions as ACCOUNTINGACTIONS } from "../../../store/actions/accountingActions";


const JournalConditionsSet = ({
	percentage,
	updateField,
	addPart,
	removePart,
	levelOptions,
	toOptions,
	selectedToOption,
	partIndex,
	lastPart,
	setData,
}) => {
	return (
		<div className={`col-xs-12 ${partIndex ? 'p-0 pt-5' : 'p-0'}`}>
			<div className="col-xs-1 p-0">
				{partIndex > 0 && percentage == null ? (
					<label className={"pull-right"}>And</label>
				):
					<div>
						<label className={"pull-right mb-0"}>Set</label>
						<div style={{
							width: "100%",
						}}>
							<input
								defaultValue={"100"}
								style={{
									width: "calc(100% - 15px)",
									textAlign: "right",
									display: "inline",
								}}
								value={percentage}
								onChange={(e) => {
									updateField("percentage", e.target.value);
								}}
							/> %
						</div>
					</div>
				}
			</div>
			<div className="col-xs-5">
				<Select
					name="set"
					placeholder="Choose One"
					options={levelOptions}
					value={levelOptions?.find((i) => i.value == setData?.set)}
					onChange={(e) => {
						updateField("set", e?.value ?? null);
					}}
				/>
			</div>
			<div className="col-xs-5">
				<label style={{
					position:"absolute",
					marginLeft: -20,
				}}>To</label>
				<Select
					name="to"
					placeholder="Choose one"
					options={toOptions}//.filter(c => c.value == center.value)}
					value={selectedToOption}
					onChange={(e) => {
						updateField("to", e?.value || null);
					}}
				/>
			</div>
			<div className="col-xs-1"
				 style={{
					display: "flex",
					padding: 0,
					// justifyContent: "space-between",
					justifyContent: "flex-end",
					 marginTop: '0.5em'
				 }}
			>

				{/*<MinusCircleIcon
						onClick={() => removePart()}
						className={"text-white"}
						style={{ height: "2.5rem", float: "left", fill:"#e83e36", cursor: "pointer"}}
					/>*/}
				<button
					className="btn btn-danger pull-left"
					style={{ padding: 3 }}
					type="button"
					onClick={() => removePart()}
				>
					<MinusCircleIcon style={{ height: "1.3em", float: "left" }} />
				</button>
				{ lastPart && (

						/*<PlusCircleIcon
							onClick={() => addPart()}
							className={"text-white"}
							style={{ height: "2.5rem", float: "left", fill:"#00bb87", cursor: "pointer"}}
						/>*/
					<button
						className="btn btn-success pull-left"
						style={{ padding: 3 }}
						type="button"
						onClick={() => addPart()}
					>
						<PlusCircleIcon
							style={{ height: "1.3em", float: "left"}}
						/>
					</button>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state,ownProps) => {

	const row = ownProps.rowIndex;
	const part = ownProps.partIndex;
	const data = state?.accounting?.journals?.conditions || [];
	const setParts = data?.[row]?.set || [];
	const setData = setParts?.[part] || [];

	const ledgers = state?.accounting?.ledgers?.data || [];
	const costCenters = state?.accounting?.costCenters?.data || [];

	// group gl options by Type for use in react-select
	const glTypes = groupBy(ledgers, "type")
	const glOptions = Object.keys(glTypes).map((type) => {
		return {
			label: type,
			options: glTypes[type].map((gl) => ({ label: `${gl?.name} (${gl?.code})`, value: gl.code }))
		}
	})

	const costCenterLevels = groupBy(costCenters, "Level")
	const levelOptions = Object.keys(costCenterLevels).map((level) => {
		return {
			label: `Level ${level}`,
			value: level
		}
	})

	levelOptions.push({ label: "General Ledger", value: 'GL' });

	const costCenterOptionsPerLevel = Object.keys(costCenterLevels).map((level) => {
		return {
			label: `Level ${level}`,
			value: level,
			options: costCenterLevels[level].map((center) => ({ label: `${center?.name} (${center?.code})`, value: center.code }))
		}
	})

	costCenterOptionsPerLevel.push({
		label: "General Ledger",
		value: 'GL',
		options: glOptions
	});

	let toOptions = []

	let selectedToOption = toOptions?.find((i) => i.value == setData?.to)

	if (setData?.set == 'GL') {
		toOptions = glOptions
		const flatGLOptions = glOptions.reduce((acc, curr) => {
			return acc.concat(curr.options);
		}, []);
		selectedToOption = flatGLOptions?.find((i) => i.value == setData?.to)
	} else {
		toOptions = costCenterOptionsPerLevel.find(c => c.value == setData?.set)?.options || []
	}


	return {
		// glOptions,
		setData,
		levelOptions,
		toOptions,
		selectedToOption,
		percentage: setData?.percentage,
	}

};

const mapDispatchToProps = (dispatch,ownProps) => ({
	updateField: (field, value) => dispatch(ACCOUNTINGACTIONS.updateJournalCondition({field, value, type: "set", row: ownProps.rowIndex, part: ownProps.partIndex})),
	addPart: () => dispatch(ACCOUNTINGACTIONS.updateJournalCondition({ type: "set", row: ownProps.rowIndex, part: ownProps.partIndex + 1})),
	removePart: () => dispatch(ACCOUNTINGACTIONS.updateJournalCondition({ type: "set", row: ownProps.rowIndex, part: ownProps.partIndex, action: "remove"})),
});

export default connect(mapStateToProps, mapDispatchToProps)(JournalConditionsSet);
